<template>
    <div class="hero _work"  :class="done">
      <media-type  :className="'hero-work-media-type'" :obj="workData.media.media" :dynAlt="'NOSSA Work'"></media-type>

      <div class="main-headline">

        <div class="master-headline">
          <div class="head-line-white">{{workData.headline.white[lang].name}}</div>
          <div class="head-line-orange">{{workData.headline.orange[lang].name}}</div>

        </div>

      </div>


      <div class="reel-bt" v-on:click="playVid()" >
       <span v-if="lang === 0">play showreel</span>
       <span v-if="lang === 1">ver showreel</span>

      </div>


      <div class="reel" :class="vis" >
        <video id="vid" >
          <source :src="workData.reel" type="video/mp4">
        </video>

        <div class="controls">
          <img src="/static/images/pause.png" v-on:click="pauseVid()" alt="">
          <img src="/static/images/volume-adjustment.png" v-on:click="muteVid()"  v-if="vol == 1" alt="">
          <img src="/static/images/mute.png" v-on:click="unmuteVid()"  v-if="vol == 0" alt="">

        </div>
      </div>


    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {

        name: 'hero-work',
      components: {MediaType},
      props: ['lang', 'workData', 'incPagePos'],
      watch: {
        'incPagePos': function () {

        //  this.reposText(this.incPagePos);

        }
      },

        data() {
            return {
                actScreen: 0,
              done: '',
              vid : {},
              vis: '',
              vol: 1

            }
        },

        created() {




        },
        mounted() {


            EVENTBUS.$on('pauseVid', this.pauseVid);
            //EVENTBUS.$emit('AAA', 0);

        //  TweenMax.to( '.master-headline', 1, {delay:0.5, x: 0 , force3D: true, ease: "circ.out"} );


         // TweenMax.to( '.hero', 1, {className:"+=done ", force3D: true, ease: "circ.out"} );

        //  this.init();

          const _this = this;


          this.vid =  document.getElementById("vid");

          setTimeout(function(){
            _this.done = 'done';


            TweenMax.to( '.head-line-orange', 1, { delay: 1, x: 0 , force3D: true, ease: Back.easeOut.config(1.4)} );
            TweenMax.to( '.head-line-white', 1, { delay: 1, x: 0 , force3D: true, ease: Back.easeOut.config(1.4)} );

          }, 100);


        },

        destroyed() {

        },

        methods: {

            init() {


             // TweenMax.to( '.sub-headline', 1, { x: '-60%' , force3D: true, ease:Back.easeOut.config(1.4)} );

            },

           playVid() {
             this.vid.play();
             this.vis = 'vis';
             this.vid.addEventListener('ended',function(){

                 EVENTBUS.$emit('pauseVid');

             },false);

          },

           pauseVid() {

               this.vid.pause();
               this.vis = '';
             this.vid.currentTime = 0;

          },

          muteVid(){
              this.vol = 0;
            this.vid.volume = this.vol;
          },

          unmuteVid(){
            this.vol = 1;
            this.vid.volume = this.vol;
          },
          reposText(n){

              let pos1 =  80 - (n * 0.4);
              let pos2 =  -110 + (n * 0.4);

              if(pos1 <= 0){
                pos1 = 0;
              }


            if(pos2 >= 0){
              pos2 = 0;
            }

              console.log(pos2)

            TweenMax.to( '.master-headline', 1, { x: pos1 +'%' , force3D: true, ease: "circ.out"} );
            TweenMax.to( '.sub-headline', 1, { x: pos2 +'%' , force3D: true, ease: "circ.out"} );

          },


        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/HeroWork.vue